'use client';

import React from 'react';
import { formatCurrency } from 'src/utils/formatCurrency/formatCurrency';
import WidgetLoading from 'src/components/Profiles/shared/widgets/shared/WidgetLoading';
import WidgetEmpty from 'src/components/Profiles/shared/widgets/shared/WidgetEmpty';
import useExpectedOpportunity from './useExpectedOpportunity';

const ExpectedOpportunityPreview: React.FC = () => {
  const { expectedOpportunity, isLoading, periodLabel, yearLabel } =
    useExpectedOpportunity();

  if (isLoading) {
    return <WidgetLoading data-testid="expected-opportunity-preview-loading" aria-label="Loading expected opportunity" />;
  }

  if (expectedOpportunity == null) {
    return <WidgetEmpty data-testid="expected-opportunity-preview-empty" />;
  }

  return (
    <div
      className="flex flex-col gap-1"
      data-testid="expected-opportunity-preview"
    >
      <span
        className="text-xs text-neutral-400"
        data-testid="expected-opportunity-preview-subtitle"
      >
        Based on {yearLabel} volume, {periodLabel}
      </span>
      <span
        className="text-3xl font-bold text-sky-900 tabular-nums mt-2"
        data-testid="expected-opportunity-preview-amount"
      >
        {formatCurrency(expectedOpportunity)}
      </span>
    </div>
  );
};

export default ExpectedOpportunityPreview;
